export const SHOW_PRELOADER = 'SHOW_PRELOADER';
export const HIDE_PRELOADER = 'HIDE_PRELOADER';

export function showPreloader() {
    return {type: SHOW_PRELOADER, payload: true}
}

export function hidePreloader() {
    return {type: HIDE_PRELOADER, payload: false}
}